import Vue from 'vue';
import router from '../router';

export default {
    async create(code, product,  purchaseStore, purchaseLocation) {
		const a = document.createElement('a');
    	a.href = router.resolve({name: 'devices.subscribe', code}).href;

        const response = await Vue.axios.post('/account/subscriptions', {
			code: code,
			product: product,
			purchaseStore: purchaseStore,
			purchaseLocation: purchaseLocation,
			redirect: a.href
		},{
            headers: {Authorization: `Bearer ${Vue.store.state.auth.token}`},
        }).catch((e) => {
            throw e;
        });

        return response.data;
    },
	async renew(token, data, expires, payload) {
		const a = document.createElement('a');
		a.href = router.resolve({name: 'subscription.renewal'}).href;

		const response = await Vue.axios.post(`/subscriptions/renew?data=${data}&expires=${expires}&signature=${token}`, {
			payload: payload,
			redirect: a.href
		}).catch((e) => {
			throw e;
		});

		return response.data;
	}
};
